import request, {METHODS} from '@/api'
import {trans} from '@/utils/common'
import {get} from 'lodash-es'
import API from '@/services/typings'
import UrlConfig, {MicroServer} from '@/api/UrlConfigs.ts'
// 待办任务列表
export const compensationSigningPage = async (
  currentPage: number,
  pageSize: number,
  data: object
) => {
  const resp = await request(
    `${UrlConfig.Task.CompensationSigningPage}/${currentPage}/${pageSize}`,
    {
      method: METHODS.POST,
      data,
    }
  )
  const records = get(resp, 'list', [])
  const total = get(resp, 'count', 0)
  return { records, total }
}

// 工单受理
export const ticketsListAccept = async (id: string | number) => {
  const resp = await request(`${UrlConfig.Crm.TicketsListAccept}?id=${id}`, {
    method: METHODS.GET,
  })
  return resp
}
// 工单退回
export const ticketsBack = async (data: object) => {
  const resp = await request(UrlConfig.Crm.TicketsBack, {
    method: METHODS.POST,
    data,
  })
  return resp
}
//获取工单详情
export const getWorkerOrderDetail = params => {
  return request(UrlConfig.Crm.GetWorkerOrderDetail, {
    method: METHODS.GET,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    params,
  })
}
// 根据key获取对应枚举项值
export const formatEmnOfSign = (enumKey, enumList) => {
  if (!Array.isArray(enumList)) return
  let singn = ''
  enumList.map(v => {
    if (v.code == enumKey) {
      singn = v.label
    }
  })
  return singn
}
// 快捷入口列表
export const fastFunctionMenuSettingList = async () => {
  const resp = await request(UrlConfig.Caas.FastFunctionMenuSettingList, {
    method: METHODS.GET,
  })
  return resp
}

// 快捷入口收藏|取消
export const fastFunctionMenuSettingAddOrDel = async (menuId: string, type: string) => {
  const resp = await request(
    `${UrlConfig.Caas.FastFunctionMenuSettingAddOrDel}?menuId=${menuId}&type=${type}`,
    {
      method: METHODS.GET,
    }
  )
  return resp
}

/**
 * 获取集团分公司
 */
export const getCompany = (option?: API.Options) => {
  return request(UrlConfig.Caas.GetCompany, { method: METHODS.POST, ...{ ...option, orgType: 'COMPANY' } })
}
// 线索：根据电话获取客户信息
export const findByPhoneExt = async phone => {
  return await request(`${UrlConfig.Clue.FindByPhoneExt}${phone}`, { method: METHODS.GET })
}

//楼盘列表(通过公司Code,handlflag是否处理查询结果)
export const getRealEstateList = (data?: any) => {
  return request(UrlConfig.PlusCrmWeb.BuildingInfo, {
    method: METHODS.POST,
    data: { ...data, handlflag: data?.handlflag ?? false, handleFlag: (data?.handlflag || data?.handleFlag) ?? false },
  })
}

/*
 * 军种权限 - 获取事业线列表
 * */
export const fetchBusinessLineList = (option?: API.Options) => {
  return request(UrlConfig.Config.FetchBusinessLineList, {
    method: METHODS.POST,
    ...option,
  })
}
// 查询下级字典列表
export const getChildrenDicts = keys => {
  return request<Array<any> | object>(UrlConfig.PlusProductWeb.GetDataDictionaryChildren, {
    method: METHODS.POST,
    data: [...keys],
  })
}
// 查询Platform下级字典列表
export const getPlatformDict = (key:string) => {
  return request<Array<any> | object>(UrlConfig.PlatformWeb.GetDataDictionaryChildren, {
    method: METHODS.POST,
    data: {parentKey:key},
  })
}
// 枚举 - 指定服务 例如: crm | config | caas
export const getEnums = (webType = 'clue', path = '') => {
  return request(`/${webType}-web/enums/${path}`, {
    method: METHODS.GET,
  })
}
// 线索：新增
export const addClue = async (option: API.Options) => {
  return await request(UrlConfig.Clue.AddClue, { method: METHODS.POST, ...option })
}

/**
 * 获取客户详情信息
 */
export const getCustomerDetails = (id: string | number, publicFlag: any) => {
  return request(
    publicFlag
      ? `${UrlConfig.Clue.GetPublicSeaDetail}/${id}`
      : `${UrlConfig.Clue.GetClueInfoDetail}${id}`,
    {
      method: METHODS.GET,
    }
  )
    .then(resp => {
      const _data: any = resp
      const _obj = {
        ..._data,
        ...(_data.customer && { ..._data.customer }),
        ...(_data.customer?.contactInfo && { ..._data.customer?.contactInfo }),
        createdTime: _data.createdTime,
        city: _data.city,
      }
      return _obj
    })
    .catch(() => {})
}
/**
 *  营销公海池--客户来源
 */
export const getCustomerSource = (option?: API.Options) => {
  return request(UrlConfig.Config.TreeWithChannel, { method: METHODS.GET, ...option })
    .then(res => {
      return trans(res) || []
    })
    .catch(() => [])
}
// 线索：状态
export const findBizState = async (option: API.Options) => {
  const { id } = option.params
  return await request(`${UrlConfig.Crm.FindBizState}${id}`, { method: METHODS.GET, ...option })
}

/**
 * 员工管理 新增编辑员工
 */
export const employeeSaveOrEdit = (url, data) => {
  return request(`${MicroServer.caas}/${url}`, {
    method: METHODS.POST,
    data,
    raw: true,
  }).then((res: any) => {
    return res
  })
}

/**
 * 员工管理  员工证件检测
 */
export const employeeCheck = data => {
  return request(UrlConfig.Caas.EmployeeCheck, {
    method: METHODS.POST,
    data,
  })
    .then((res: any) => {
      return res
    })
    .catch((error: any) => {
      return error
    })
}
/**
 *  组织管理 员工列表
 */
export const getEmployeeList = (data, params) => {
  return request(UrlConfig.Caas.GetEmployeeList, {
    method: METHODS.POST,
    data,
    params,
  }).then((res: any) => {
    const data = get(res, 'list')
    return data
  })
}
/**
 *  员工管理  重置密码
 */
export const resetPassword = params => {
  return request(UrlConfig.Caas.ResetPassword, {
    method: METHODS.GET,
    params,
  }).then((res: any) => {
    const msg = get(res, 'data.msg')
    return msg
  })
}
/**
 *  职位管理 全部职位
 */
export const getPositionList = (data = {}) => {
  return request(UrlConfig.Caas.GetPositionList, {
    method: METHODS.POST,
    data,
  }).then((res: any) => {
    // const data = get(res, 'data');
    return res
  })
}

/**
 *  组织管理 组织列表
 */
export const getOrgList = (data = {}, params = {}) => {
  return request(UrlConfig.Caas.GetOrgList, {
    method: METHODS.POST,
    data,
    params,
  }).then((res: any) => {
    // const records = get(res, 'data.result', []);
    // const tree = convertListToTree(records);
    return res
  })
}

export const getCustomerInfo = (paramObj = '') => {
  return request(UrlConfig.Crm.GetCustomerInfo, {
    params: { keywords: paramObj },
    method: METHODS.GET,
  })
}

/**
 * 获取问题详情
 */
export const getIssueDetail = (issueId: any) => {
  return request(`${UrlConfig.Crm.GetIssueDetail}${issueId}`, {
    method: METHODS.GET,
  })
}
/**
 * 新增/编辑问题
 */
export const addIssueOrUpdate = data => {
  return request(
    data?.id > 0 ? UrlConfig.Crm.TicketsIssueListUpdate : UrlConfig.Crm.TicketsIssueListAdd,
    {
      method: METHODS.POST,
      data,
      raw: true,
    }
  )
}

/**
 * 获取公司列表
 * @param {string} data.companyType - 类型  group:集团  company:分公司
 */
export const httpCompanyList = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Caas.HttpCompanyList, {
      method: METHODS.POST,
      data: {
        status: true,
        orgType: 'COMPANY',
        ...data,
      },
    })
    resolve(resData)
  })
}
/**
 * 获取公司列表+通用
 * @param {string} data.companyType - 类型  group:集团  company:分公司
 */
export const selectcompanyByFront = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Caas.SelectcompanyByFront, {
      method: METHODS.POST,
      data: {
        status: true,
        orgType: 'COMPANY',
        ...data,
      },
    })
    resolve(resData)
  })
}

/**
 * 获取公司列表带权限
 * @param {string} data.companyType - 类型  group:集团  company:分公司
 */
export const searchCompanyList = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.plusPmWeb.SearchCompanyList, {
      method: METHODS.POST,
      data: {
        status: true,
        ...data,
      }
    })
    resolve(resData)
  })
}
/**
 * 获取公司组织列表
 * @param {string} data.companyType - 类型  group:集团  company:分公司
 */
export const httpOrgList = (data?: {}) => {
  return new Promise(async resolve => {
    const resData: any = await request(UrlConfig.Caas.HttpOrgList, {
      method: METHODS.POST,
      data: {
        status: true,
        orgType: 'COMPANY',
        ...data,
      },
    })
    resolve(resData)
  })
}

/**
 * 工单 - 渠道
 */
export const getTicketsChannelConfigTree = () => {
  return request(UrlConfig.Crm.GetTicketsChannelConfigTree, {
    method: METHODS.GET,
  })
}

/**
 * 工单 - 对内分类
 */
export const getTicketsInternalConfigTree = () => {
  return request(UrlConfig.Crm.GetTicketsInternalConfigTree, {
    method: METHODS.GET,
  })
}

/**
 * 工单 - 曝光渠道
 */
export const getTicketsExposureConfigTree = () => {
  return request(UrlConfig.Crm.GetTicketsExposureConfigTree, {
    method: METHODS.GET,
  })
}

/**
 * 数据看板
 */
export const galleryGetData = (data: object) => {
  return request(UrlConfig.Report.GalleryGetData, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 天气查询
 */
export const weatherCurrent = () => {
  return request(UrlConfig.Report.WeatherCurrent, {
    method: METHODS.GET,
  })
}
// 搜索栏 分公司下拉
export function getBranchComponyList() {
  return request(UrlConfig.Caas.GetCompany, {
    method: METHODS.POST,
    data: {
      orgType: 'COMPANY',
      status: true
    },
  })
}
//  所有公司
export const getAllCompany = async (option?: API.Options) => {
  const resp = await request(UrlConfig.Caas.GetPrivilegesComPany, {
    method: METHODS.GET,
    ...option,
  })
  return resp || []
}
/*
 * 获取事业线列表
 * */
export const getBusinessLinesByDeptCode = (option?: API.Options) => {
  return request(`/config-web/businessLine/getBusinessLines`, {
    method: METHODS.GET,
    ...option,
  })
}
// 线索：编辑
export const updateClue = async (option: API.Options) => {
  return await request(
    // `/clue-web/clueInfo/updateClue`
    UrlConfig.Clue.UpdateClue,
    { method: METHODS.POST, ...option }
  )
}
// 角色查询-page
export const getRolePage = async (option) => {
  return await request(
    // `/clue-web/clueInfo/updateClue`
    UrlConfig.Caas.GetRolePage,
    { method: METHODS.POST, ...option }
  )
}
// 角色查询-list
export const getRoleList = async (option) => {
  return await request(
    // `/clue-web/clueInfo/updateClue`
    UrlConfig.Caas.GetRoleList,
    { method: METHODS.POST, ...option }
  )
}
